import React, { useState } from 'react';
import DimensionTable from './DimensionTable';
import AppDimensionTable from './AppDimensionTable';
import { DimensionTableWrapper, StyledAlert } from './styled';
import DimensionSelector from './DimensionSelector';
import RemoveDimension from './RemoveDimension';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import DragHandle from '@components/common/DnD/DragHandle';
import { tid } from '@utils/test';
import { isAppModule } from '@utils/constants';
import { BASE_HEIGHT, TABLE_HEIGHT_MAPPING } from '../header/Resize';
import { useSelector } from 'react-redux';
import { dimensionsToNASelector } from '@store/trends/base/selectors';
import { NoData } from '@components/common/Retry/styled';
import { InfoCircleOutlined } from '@ant-design/icons';

function DimensionTableWidget({ dimension }) {
  const [gridRow, updateGrid] = useState(TABLE_HEIGHT_MAPPING.s);
  const dimensionsToNA = useSelector(dimensionsToNASelector);
  const isNADimension = dimensionsToNA.includes(dimension);
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({
    id: dimension,
  });
  const dndStyle = {
    transform: CSS.Transform.toString(transform),
    transition,
    gridRow: isNADimension ? `span ${BASE_HEIGHT}` : `span ${gridRow}`,
  };

  const renderTables = () => {
    if (isAppModule) {
      return <AppDimensionTable dimension={dimension} updateGrid={updateGrid} />;
    }

    if (isNADimension) {
      return (
        <NoData emptyPlaceholder="Not Applicable">
          <StyledAlert
            message="Please order by Ad metrics to get data."
            type="warning"
            showIcon
            icon={<InfoCircleOutlined style={{ color: '#FF9300' }} />}
          />
        </NoData>
      ); // putting condition here to avoid unwanted metric calls to BE
    }

    return <DimensionTable dimension={dimension} updateGrid={updateGrid} />;
  };

  return (
    <DimensionTableWrapper
      id={dimension}
      ref={setNodeRef}
      style={dndStyle}
      {...tid(`dimension-table::${dimension}`)}
    >
      <DragHandle {...attributes} {...listeners} />
      <DimensionSelector dimension={dimension} />
      <RemoveDimension dimension={dimension} />
      {renderTables()}
    </DimensionTableWrapper>
  );
}

export default React.memo(DimensionTableWidget);
